import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Header = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "spaced" && prop !== "stickyHeight",
})(({ spaced, stickyHeight, theme }) => ({
  background: "white",
  zIndex: 2,
  width: "100%",
  maxWidth: "100%",
  paddingTop: theme.spacing(3),
  paddingBottom: spaced ? theme.spacing(3) : 0,
  position: "sticky",
  boxSizing: "border-box",
  left: 0,
  top: stickyHeight ? `-${stickyHeight}px` : "0px",
}));
